import styles from './Loading.module.scss';

const Loading = () => {
  return (
    <div data-test-id='loading' className={styles.rootLoading}>
      <div className={styles.containerLoading}>
        <img src={`${process.env.PUBLIC_URL}/images/loading/4.gif`} alt='loading...' />
      </div>
    </div>
  );
};

export default Loading;
